// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/a2ui/v1/components.proto" (package "c1.api.a2ui.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * A2UIComponent - typed discriminated union for UI components.
 * Uses oneof for proper TypeScript discrimination.
 *
 * @generated from protobuf message c1.api.a2ui.v1.A2UIComponent
 */
export interface A2UIComponent {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: int32 weight = 2
     */
    weight: number; // For ordering
    /**
     * @generated from protobuf oneof: component
     */
    component: {
        oneofKind: "text";
        /**
         * Display
         *
         * @generated from protobuf field: c1.api.a2ui.v1.TextComponent text = 10
         */
        text: TextComponent;
    } | {
        oneofKind: "textField";
        /**
         * Input
         *
         * @generated from protobuf field: c1.api.a2ui.v1.TextFieldComponent text_field = 20
         */
        textField: TextFieldComponent;
    } | {
        oneofKind: "checkBox";
        /**
         * @generated from protobuf field: c1.api.a2ui.v1.CheckBoxComponent check_box = 21
         */
        checkBox: CheckBoxComponent;
    } | {
        oneofKind: "choicePicker";
        /**
         * @generated from protobuf field: c1.api.a2ui.v1.ChoicePickerComponent choice_picker = 22
         */
        choicePicker: ChoicePickerComponent;
    } | {
        oneofKind: "dateTimeInput";
        /**
         * @generated from protobuf field: c1.api.a2ui.v1.DateTimeInputComponent date_time_input = 23
         */
        dateTimeInput: DateTimeInputComponent;
    } | {
        oneofKind: "slider";
        /**
         * @generated from protobuf field: c1.api.a2ui.v1.SliderComponent slider = 24
         */
        slider: SliderComponent;
    } | {
        oneofKind: "button";
        /**
         * Interactive
         *
         * @generated from protobuf field: c1.api.a2ui.v1.ButtonComponent button = 30
         */
        button: ButtonComponent;
    } | {
        oneofKind: "row";
        /**
         * Layout
         *
         * @generated from protobuf field: c1.api.a2ui.v1.RowComponent row = 40
         */
        row: RowComponent;
    } | {
        oneofKind: "column";
        /**
         * @generated from protobuf field: c1.api.a2ui.v1.ColumnComponent column = 41
         */
        column: ColumnComponent;
    } | {
        oneofKind: "card";
        /**
         * @generated from protobuf field: c1.api.a2ui.v1.CardComponent card = 42
         */
        card: CardComponent;
    } | {
        oneofKind: "divider";
        /**
         * @generated from protobuf field: c1.api.a2ui.v1.DividerComponent divider = 43
         */
        divider: DividerComponent;
    } | {
        oneofKind: "c1StatusIndicator";
        /**
         * C1 Custom
         *
         * @generated from protobuf field: c1.api.a2ui.v1.C1StatusIndicatorComponent c1_status_indicator = 100
         */
        c1StatusIndicator: C1StatusIndicatorComponent;
    } | {
        oneofKind: "c1CodeBlock";
        /**
         * @generated from protobuf field: c1.api.a2ui.v1.C1CodeBlockComponent c1_code_block = 101
         */
        c1CodeBlock: C1CodeBlockComponent;
    } | {
        oneofKind: "c1ResourcePicker";
        /**
         * @generated from protobuf field: c1.api.a2ui.v1.C1ResourcePickerComponent c1_resource_picker = 102
         */
        c1ResourcePicker: C1ResourcePickerComponent;
    } | {
        oneofKind: undefined;
    };
}
// ═══════════════════════════════════════════════════════════════
// VALUE BINDING TYPES
// ═══════════════════════════════════════════════════════════════

/**
 * DynamicString can be a literal value, a JSON pointer path, or a function call.
 *
 * @generated from protobuf message c1.api.a2ui.v1.DynamicString
 */
export interface DynamicString {
    /**
     * @generated from protobuf oneof: value
     */
    value: {
        oneofKind: "literal";
        /**
         * @generated from protobuf field: string literal = 1
         */
        literal: string;
    } | {
        oneofKind: "path";
        /**
         * @generated from protobuf field: string path = 2
         */
        path: string; // JSON Pointer (RFC 6901)
    } | {
        oneofKind: "call";
        /**
         * @generated from protobuf field: c1.api.a2ui.v1.FunctionCall call = 3
         */
        call: FunctionCall;
    } | {
        oneofKind: undefined;
    };
}
/**
 * DynamicBool can be a literal value, a JSON pointer path, or a function call.
 *
 * @generated from protobuf message c1.api.a2ui.v1.DynamicBool
 */
export interface DynamicBool {
    /**
     * @generated from protobuf oneof: value
     */
    value: {
        oneofKind: "literal";
        /**
         * @generated from protobuf field: bool literal = 1
         */
        literal: boolean;
    } | {
        oneofKind: "path";
        /**
         * @generated from protobuf field: string path = 2
         */
        path: string;
    } | {
        oneofKind: "call";
        /**
         * @generated from protobuf field: c1.api.a2ui.v1.FunctionCall call = 3
         */
        call: FunctionCall;
    } | {
        oneofKind: undefined;
    };
}
/**
 * DynamicNumber can be a literal value, a JSON pointer path, or a function call.
 *
 * @generated from protobuf message c1.api.a2ui.v1.DynamicNumber
 */
export interface DynamicNumber {
    /**
     * @generated from protobuf oneof: value
     */
    value: {
        oneofKind: "literal";
        /**
         * @generated from protobuf field: double literal = 1
         */
        literal: number;
    } | {
        oneofKind: "path";
        /**
         * @generated from protobuf field: string path = 2
         */
        path: string;
    } | {
        oneofKind: "call";
        /**
         * @generated from protobuf field: c1.api.a2ui.v1.FunctionCall call = 3
         */
        call: FunctionCall;
    } | {
        oneofKind: undefined;
    };
}
/**
 * FunctionCall represents a client-side function invocation.
 *
 * @generated from protobuf message c1.api.a2ui.v1.FunctionCall
 */
export interface FunctionCall {
    /**
     * @generated from protobuf field: string call = 1
     */
    call: string; // Function name: "required", "email", "regex", "openUrl", "copyToClipboard"
    /**
     * @generated from protobuf field: map<string, string> args = 2
     */
    args: {
        [key: string]: string;
    };
    /**
     * @generated from protobuf field: string message = 3
     */
    message: string; // Error message on validation failure
}
/**
 * ValidationCheck for client-side validation rules.
 *
 * @generated from protobuf message c1.api.a2ui.v1.ValidationCheck
 */
export interface ValidationCheck {
    /**
     * @generated from protobuf oneof: check
     */
    check: {
        oneofKind: "call";
        /**
         * @generated from protobuf field: c1.api.a2ui.v1.FunctionCall call = 1
         */
        call: FunctionCall;
    } | {
        oneofKind: "and";
        /**
         * @generated from protobuf field: c1.api.a2ui.v1.AndCheck and = 2
         */
        and: AndCheck;
    } | {
        oneofKind: "or";
        /**
         * @generated from protobuf field: c1.api.a2ui.v1.OrCheck or = 3
         */
        or: OrCheck;
    } | {
        oneofKind: undefined;
    };
}
/**
 * AndCheck requires all checks to pass.
 *
 * @generated from protobuf message c1.api.a2ui.v1.AndCheck
 */
export interface AndCheck {
    /**
     * @generated from protobuf field: repeated c1.api.a2ui.v1.ValidationCheck checks = 1
     */
    checks: ValidationCheck[];
}
/**
 * OrCheck requires at least one check to pass.
 *
 * @generated from protobuf message c1.api.a2ui.v1.OrCheck
 */
export interface OrCheck {
    /**
     * @generated from protobuf field: repeated c1.api.a2ui.v1.ValidationCheck checks = 1
     */
    checks: ValidationCheck[];
}
/**
 * Action represents what happens when a component is activated (e.g., button click).
 *
 * @generated from protobuf message c1.api.a2ui.v1.Action
 */
export interface Action {
    /**
     * @generated from protobuf oneof: action_type
     */
    actionType: {
        oneofKind: "event";
        /**
         * @generated from protobuf field: c1.api.a2ui.v1.ServerEvent event = 1
         */
        event: ServerEvent; // Server action
    } | {
        oneofKind: "functionCall";
        /**
         * @generated from protobuf field: c1.api.a2ui.v1.FunctionCall function_call = 2
         */
        functionCall: FunctionCall; // Client action
    } | {
        oneofKind: undefined;
    };
}
/**
 * ServerEvent triggers a server-side action.
 *
 * @generated from protobuf message c1.api.a2ui.v1.ServerEvent
 */
export interface ServerEvent {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: map<string, string> context = 2
     */
    context: {
        [key: string]: string;
    }; // Resolved from data model
}
/**
 * ChildList contains references to child component IDs.
 *
 * @generated from protobuf message c1.api.a2ui.v1.ChildList
 */
export interface ChildList {
    /**
     * @generated from protobuf field: repeated string ids = 1
     */
    ids: string[];
}
/**
 * Choice represents a single option in a choice picker.
 *
 * @generated from protobuf message c1.api.a2ui.v1.Choice
 */
export interface Choice {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicString label = 2
     */
    label?: DynamicString;
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicString description = 3
     */
    description?: DynamicString;
}
// ═══════════════════════════════════════════════════════════════
// DISPLAY COMPONENTS
// ═══════════════════════════════════════════════════════════════

/**
 * TextComponent displays text content.
 *
 * @generated from protobuf message c1.api.a2ui.v1.TextComponent
 */
export interface TextComponent {
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicString text = 1
     */
    text?: DynamicString;
    /**
     * @generated from protobuf field: bool markdown = 2
     */
    markdown: boolean;
}
// ═══════════════════════════════════════════════════════════════
// INPUT COMPONENTS
// ═══════════════════════════════════════════════════════════════

/**
 * TextFieldComponent is a text input field.
 *
 * @generated from protobuf message c1.api.a2ui.v1.TextFieldComponent
 */
export interface TextFieldComponent {
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicString label = 1
     */
    label?: DynamicString;
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicString placeholder = 2
     */
    placeholder?: DynamicString;
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicString value = 3
     */
    value?: DynamicString;
    /**
     * @generated from protobuf field: bool multiline = 4
     */
    multiline: boolean;
    /**
     * @generated from protobuf field: repeated c1.api.a2ui.v1.FunctionCall checks = 5
     */
    checks: FunctionCall[]; // Validation checks
}
/**
 * CheckBoxComponent is a boolean checkbox.
 *
 * @generated from protobuf message c1.api.a2ui.v1.CheckBoxComponent
 */
export interface CheckBoxComponent {
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicString label = 1
     */
    label?: DynamicString;
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicBool value = 2
     */
    value?: DynamicBool;
}
/**
 * ChoicePickerComponent allows selection from predefined choices.
 *
 * @generated from protobuf message c1.api.a2ui.v1.ChoicePickerComponent
 */
export interface ChoicePickerComponent {
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicString label = 1
     */
    label?: DynamicString;
    /**
     * @generated from protobuf field: repeated c1.api.a2ui.v1.Choice choices = 2
     */
    choices: Choice[];
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicString value = 3
     */
    value?: DynamicString;
    /**
     * @generated from protobuf field: bool multi_select = 4
     */
    multiSelect: boolean;
}
/**
 * DateTimeInputComponent for date/time selection.
 *
 * @generated from protobuf message c1.api.a2ui.v1.DateTimeInputComponent
 */
export interface DateTimeInputComponent {
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicString label = 1
     */
    label?: DynamicString;
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicString value = 2
     */
    value?: DynamicString;
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DateTimeInputType input_type = 3
     */
    inputType: DateTimeInputType;
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicString min = 4
     */
    min?: DynamicString;
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicString max = 5
     */
    max?: DynamicString;
}
/**
 * SliderComponent for numeric range selection.
 *
 * @generated from protobuf message c1.api.a2ui.v1.SliderComponent
 */
export interface SliderComponent {
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicString label = 1
     */
    label?: DynamicString;
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicNumber value = 2
     */
    value?: DynamicNumber;
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicNumber min = 3
     */
    min?: DynamicNumber;
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicNumber max = 4
     */
    max?: DynamicNumber;
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicNumber step = 5
     */
    step?: DynamicNumber;
}
// ═══════════════════════════════════════════════════════════════
// INTERACTIVE COMPONENTS
// ═══════════════════════════════════════════════════════════════

/**
 * ButtonComponent triggers actions.
 *
 * @generated from protobuf message c1.api.a2ui.v1.ButtonComponent
 */
export interface ButtonComponent {
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicString label = 1
     */
    label?: DynamicString;
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.Action action = 2
     */
    action?: Action;
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicBool disabled = 3
     */
    disabled?: DynamicBool;
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.ButtonComponent.ButtonVariant variant = 4
     */
    variant: ButtonComponent_ButtonVariant;
    /**
     * @generated from protobuf field: repeated c1.api.a2ui.v1.ValidationCheck checks = 5
     */
    checks: ValidationCheck[]; // Auto-disable validation
}
/**
 * @generated from protobuf enum c1.api.a2ui.v1.ButtonComponent.ButtonVariant
 */
export enum ButtonComponent_ButtonVariant {
    /**
     * @generated from protobuf enum value: BUTTON_VARIANT_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: BUTTON_VARIANT_PRIMARY = 1;
     */
    PRIMARY = 1,
    /**
     * @generated from protobuf enum value: BUTTON_VARIANT_SECONDARY = 2;
     */
    SECONDARY = 2,
    /**
     * @generated from protobuf enum value: BUTTON_VARIANT_TEXT = 3;
     */
    TEXT = 3
}
// ═══════════════════════════════════════════════════════════════
// LAYOUT COMPONENTS
// ═══════════════════════════════════════════════════════════════

/**
 * RowComponent arranges children horizontally.
 *
 * @generated from protobuf message c1.api.a2ui.v1.RowComponent
 */
export interface RowComponent {
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.ChildList children = 1
     */
    children?: ChildList;
    /**
     * @generated from protobuf field: string distribution = 2
     */
    distribution: string; // "equal", "start", "end", "center", "space-between"
    /**
     * @generated from protobuf field: string alignment = 3
     */
    alignment: string; // "start", "center", "end", "stretch"
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicNumber gap = 4
     */
    gap?: DynamicNumber;
}
/**
 * ColumnComponent arranges children vertically.
 *
 * @generated from protobuf message c1.api.a2ui.v1.ColumnComponent
 */
export interface ColumnComponent {
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.ChildList children = 1
     */
    children?: ChildList;
    /**
     * @generated from protobuf field: string distribution = 2
     */
    distribution: string;
    /**
     * @generated from protobuf field: string alignment = 3
     */
    alignment: string;
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicNumber gap = 4
     */
    gap?: DynamicNumber;
}
/**
 * CardComponent is a container with styling.
 *
 * @generated from protobuf message c1.api.a2ui.v1.CardComponent
 */
export interface CardComponent {
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.ChildList children = 1
     */
    children?: ChildList;
}
/**
 * DividerComponent is a visual separator.
 *
 * @generated from protobuf message c1.api.a2ui.v1.DividerComponent
 */
export interface DividerComponent {
    /**
     * @generated from protobuf field: string orientation = 1
     */
    orientation: string; // "horizontal" or "vertical"
}
// ═══════════════════════════════════════════════════════════════
// C1 CUSTOM COMPONENTS
// ═══════════════════════════════════════════════════════════════

/**
 * C1StatusIndicatorComponent shows agent progress status.
 *
 * @generated from protobuf message c1.api.a2ui.v1.C1StatusIndicatorComponent
 */
export interface C1StatusIndicatorComponent {
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicString status = 1
     */
    status?: DynamicString; // "thinking", "tool_calling", "generating", "error"
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicString message = 2
     */
    message?: DynamicString;
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicString tool_name = 3
     */
    toolName?: DynamicString;
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicBool show_spinner = 4
     */
    showSpinner?: DynamicBool;
}
/**
 * C1CodeBlockComponent displays code with syntax highlighting.
 *
 * @generated from protobuf message c1.api.a2ui.v1.C1CodeBlockComponent
 */
export interface C1CodeBlockComponent {
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicString code = 1
     */
    code?: DynamicString;
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicString language = 2
     */
    language?: DynamicString;
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicString title = 3
     */
    title?: DynamicString;
    /**
     * @generated from protobuf field: bool copyable = 4
     */
    copyable: boolean;
}
/**
 * C1ResourcePickerComponent allows selecting C1 resources.
 *
 * @generated from protobuf message c1.api.a2ui.v1.C1ResourcePickerComponent
 */
export interface C1ResourcePickerComponent {
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicString label = 1
     */
    label?: DynamicString;
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.DynamicString value = 2
     */
    value?: DynamicString; // Selected resource ID
    /**
     * @generated from protobuf field: string resource_type = 3
     */
    resourceType: string; // "app", "entitlement", "user", etc.
    /**
     * @generated from protobuf field: bool multi_select = 4
     */
    multiSelect: boolean;
}
/**
 * DateTimeInputType specifies the type of date/time input.
 *
 * @generated from protobuf enum c1.api.a2ui.v1.DateTimeInputType
 */
export enum DateTimeInputType {
    /**
     * @generated from protobuf enum value: DATE_TIME_INPUT_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: DATE_TIME_INPUT_TYPE_DATE = 1;
     */
    DATE = 1,
    /**
     * @generated from protobuf enum value: DATE_TIME_INPUT_TYPE_TIME = 2;
     */
    TIME = 2,
    /**
     * @generated from protobuf enum value: DATE_TIME_INPUT_TYPE_DATE_TIME = 3;
     */
    DATE_TIME = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class A2UIComponent$Type extends MessageType<A2UIComponent> {
    constructor() {
        super("c1.api.a2ui.v1.A2UIComponent", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "weight", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "text", kind: "message", oneof: "component", T: () => TextComponent },
            { no: 20, name: "text_field", kind: "message", oneof: "component", T: () => TextFieldComponent },
            { no: 21, name: "check_box", kind: "message", oneof: "component", T: () => CheckBoxComponent },
            { no: 22, name: "choice_picker", kind: "message", oneof: "component", T: () => ChoicePickerComponent },
            { no: 23, name: "date_time_input", kind: "message", oneof: "component", T: () => DateTimeInputComponent },
            { no: 24, name: "slider", kind: "message", oneof: "component", T: () => SliderComponent },
            { no: 30, name: "button", kind: "message", oneof: "component", T: () => ButtonComponent },
            { no: 40, name: "row", kind: "message", oneof: "component", T: () => RowComponent },
            { no: 41, name: "column", kind: "message", oneof: "component", T: () => ColumnComponent },
            { no: 42, name: "card", kind: "message", oneof: "component", T: () => CardComponent },
            { no: 43, name: "divider", kind: "message", oneof: "component", T: () => DividerComponent },
            { no: 100, name: "c1_status_indicator", kind: "message", oneof: "component", T: () => C1StatusIndicatorComponent },
            { no: 101, name: "c1_code_block", kind: "message", oneof: "component", T: () => C1CodeBlockComponent },
            { no: 102, name: "c1_resource_picker", kind: "message", oneof: "component", T: () => C1ResourcePickerComponent }
        ]);
    }
    create(value?: PartialMessage<A2UIComponent>): A2UIComponent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.weight = 0;
        message.component = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<A2UIComponent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: A2UIComponent): A2UIComponent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* int32 weight */ 2:
                    message.weight = reader.int32();
                    break;
                case /* c1.api.a2ui.v1.TextComponent text */ 10:
                    message.component = {
                        oneofKind: "text",
                        text: TextComponent.internalBinaryRead(reader, reader.uint32(), options, (message.component as any).text)
                    };
                    break;
                case /* c1.api.a2ui.v1.TextFieldComponent text_field */ 20:
                    message.component = {
                        oneofKind: "textField",
                        textField: TextFieldComponent.internalBinaryRead(reader, reader.uint32(), options, (message.component as any).textField)
                    };
                    break;
                case /* c1.api.a2ui.v1.CheckBoxComponent check_box */ 21:
                    message.component = {
                        oneofKind: "checkBox",
                        checkBox: CheckBoxComponent.internalBinaryRead(reader, reader.uint32(), options, (message.component as any).checkBox)
                    };
                    break;
                case /* c1.api.a2ui.v1.ChoicePickerComponent choice_picker */ 22:
                    message.component = {
                        oneofKind: "choicePicker",
                        choicePicker: ChoicePickerComponent.internalBinaryRead(reader, reader.uint32(), options, (message.component as any).choicePicker)
                    };
                    break;
                case /* c1.api.a2ui.v1.DateTimeInputComponent date_time_input */ 23:
                    message.component = {
                        oneofKind: "dateTimeInput",
                        dateTimeInput: DateTimeInputComponent.internalBinaryRead(reader, reader.uint32(), options, (message.component as any).dateTimeInput)
                    };
                    break;
                case /* c1.api.a2ui.v1.SliderComponent slider */ 24:
                    message.component = {
                        oneofKind: "slider",
                        slider: SliderComponent.internalBinaryRead(reader, reader.uint32(), options, (message.component as any).slider)
                    };
                    break;
                case /* c1.api.a2ui.v1.ButtonComponent button */ 30:
                    message.component = {
                        oneofKind: "button",
                        button: ButtonComponent.internalBinaryRead(reader, reader.uint32(), options, (message.component as any).button)
                    };
                    break;
                case /* c1.api.a2ui.v1.RowComponent row */ 40:
                    message.component = {
                        oneofKind: "row",
                        row: RowComponent.internalBinaryRead(reader, reader.uint32(), options, (message.component as any).row)
                    };
                    break;
                case /* c1.api.a2ui.v1.ColumnComponent column */ 41:
                    message.component = {
                        oneofKind: "column",
                        column: ColumnComponent.internalBinaryRead(reader, reader.uint32(), options, (message.component as any).column)
                    };
                    break;
                case /* c1.api.a2ui.v1.CardComponent card */ 42:
                    message.component = {
                        oneofKind: "card",
                        card: CardComponent.internalBinaryRead(reader, reader.uint32(), options, (message.component as any).card)
                    };
                    break;
                case /* c1.api.a2ui.v1.DividerComponent divider */ 43:
                    message.component = {
                        oneofKind: "divider",
                        divider: DividerComponent.internalBinaryRead(reader, reader.uint32(), options, (message.component as any).divider)
                    };
                    break;
                case /* c1.api.a2ui.v1.C1StatusIndicatorComponent c1_status_indicator */ 100:
                    message.component = {
                        oneofKind: "c1StatusIndicator",
                        c1StatusIndicator: C1StatusIndicatorComponent.internalBinaryRead(reader, reader.uint32(), options, (message.component as any).c1StatusIndicator)
                    };
                    break;
                case /* c1.api.a2ui.v1.C1CodeBlockComponent c1_code_block */ 101:
                    message.component = {
                        oneofKind: "c1CodeBlock",
                        c1CodeBlock: C1CodeBlockComponent.internalBinaryRead(reader, reader.uint32(), options, (message.component as any).c1CodeBlock)
                    };
                    break;
                case /* c1.api.a2ui.v1.C1ResourcePickerComponent c1_resource_picker */ 102:
                    message.component = {
                        oneofKind: "c1ResourcePicker",
                        c1ResourcePicker: C1ResourcePickerComponent.internalBinaryRead(reader, reader.uint32(), options, (message.component as any).c1ResourcePicker)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: A2UIComponent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* int32 weight = 2; */
        if (message.weight !== 0)
            writer.tag(2, WireType.Varint).int32(message.weight);
        /* c1.api.a2ui.v1.TextComponent text = 10; */
        if (message.component.oneofKind === "text")
            TextComponent.internalBinaryWrite(message.component.text, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.TextFieldComponent text_field = 20; */
        if (message.component.oneofKind === "textField")
            TextFieldComponent.internalBinaryWrite(message.component.textField, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.CheckBoxComponent check_box = 21; */
        if (message.component.oneofKind === "checkBox")
            CheckBoxComponent.internalBinaryWrite(message.component.checkBox, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.ChoicePickerComponent choice_picker = 22; */
        if (message.component.oneofKind === "choicePicker")
            ChoicePickerComponent.internalBinaryWrite(message.component.choicePicker, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.DateTimeInputComponent date_time_input = 23; */
        if (message.component.oneofKind === "dateTimeInput")
            DateTimeInputComponent.internalBinaryWrite(message.component.dateTimeInput, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.SliderComponent slider = 24; */
        if (message.component.oneofKind === "slider")
            SliderComponent.internalBinaryWrite(message.component.slider, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.ButtonComponent button = 30; */
        if (message.component.oneofKind === "button")
            ButtonComponent.internalBinaryWrite(message.component.button, writer.tag(30, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.RowComponent row = 40; */
        if (message.component.oneofKind === "row")
            RowComponent.internalBinaryWrite(message.component.row, writer.tag(40, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.ColumnComponent column = 41; */
        if (message.component.oneofKind === "column")
            ColumnComponent.internalBinaryWrite(message.component.column, writer.tag(41, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.CardComponent card = 42; */
        if (message.component.oneofKind === "card")
            CardComponent.internalBinaryWrite(message.component.card, writer.tag(42, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.DividerComponent divider = 43; */
        if (message.component.oneofKind === "divider")
            DividerComponent.internalBinaryWrite(message.component.divider, writer.tag(43, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.C1StatusIndicatorComponent c1_status_indicator = 100; */
        if (message.component.oneofKind === "c1StatusIndicator")
            C1StatusIndicatorComponent.internalBinaryWrite(message.component.c1StatusIndicator, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.C1CodeBlockComponent c1_code_block = 101; */
        if (message.component.oneofKind === "c1CodeBlock")
            C1CodeBlockComponent.internalBinaryWrite(message.component.c1CodeBlock, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.C1ResourcePickerComponent c1_resource_picker = 102; */
        if (message.component.oneofKind === "c1ResourcePicker")
            C1ResourcePickerComponent.internalBinaryWrite(message.component.c1ResourcePicker, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.A2UIComponent
 */
export const A2UIComponent = new A2UIComponent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DynamicString$Type extends MessageType<DynamicString> {
    constructor() {
        super("c1.api.a2ui.v1.DynamicString", [
            { no: 1, name: "literal", kind: "scalar", oneof: "value", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "path", kind: "scalar", oneof: "value", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "call", kind: "message", oneof: "value", T: () => FunctionCall }
        ]);
    }
    create(value?: PartialMessage<DynamicString>): DynamicString {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.value = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<DynamicString>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DynamicString): DynamicString {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string literal */ 1:
                    message.value = {
                        oneofKind: "literal",
                        literal: reader.string()
                    };
                    break;
                case /* string path */ 2:
                    message.value = {
                        oneofKind: "path",
                        path: reader.string()
                    };
                    break;
                case /* c1.api.a2ui.v1.FunctionCall call */ 3:
                    message.value = {
                        oneofKind: "call",
                        call: FunctionCall.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).call)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DynamicString, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string literal = 1; */
        if (message.value.oneofKind === "literal")
            writer.tag(1, WireType.LengthDelimited).string(message.value.literal);
        /* string path = 2; */
        if (message.value.oneofKind === "path")
            writer.tag(2, WireType.LengthDelimited).string(message.value.path);
        /* c1.api.a2ui.v1.FunctionCall call = 3; */
        if (message.value.oneofKind === "call")
            FunctionCall.internalBinaryWrite(message.value.call, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.DynamicString
 */
export const DynamicString = new DynamicString$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DynamicBool$Type extends MessageType<DynamicBool> {
    constructor() {
        super("c1.api.a2ui.v1.DynamicBool", [
            { no: 1, name: "literal", kind: "scalar", oneof: "value", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "path", kind: "scalar", oneof: "value", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "call", kind: "message", oneof: "value", T: () => FunctionCall }
        ]);
    }
    create(value?: PartialMessage<DynamicBool>): DynamicBool {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.value = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<DynamicBool>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DynamicBool): DynamicBool {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool literal */ 1:
                    message.value = {
                        oneofKind: "literal",
                        literal: reader.bool()
                    };
                    break;
                case /* string path */ 2:
                    message.value = {
                        oneofKind: "path",
                        path: reader.string()
                    };
                    break;
                case /* c1.api.a2ui.v1.FunctionCall call */ 3:
                    message.value = {
                        oneofKind: "call",
                        call: FunctionCall.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).call)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DynamicBool, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool literal = 1; */
        if (message.value.oneofKind === "literal")
            writer.tag(1, WireType.Varint).bool(message.value.literal);
        /* string path = 2; */
        if (message.value.oneofKind === "path")
            writer.tag(2, WireType.LengthDelimited).string(message.value.path);
        /* c1.api.a2ui.v1.FunctionCall call = 3; */
        if (message.value.oneofKind === "call")
            FunctionCall.internalBinaryWrite(message.value.call, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.DynamicBool
 */
export const DynamicBool = new DynamicBool$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DynamicNumber$Type extends MessageType<DynamicNumber> {
    constructor() {
        super("c1.api.a2ui.v1.DynamicNumber", [
            { no: 1, name: "literal", kind: "scalar", oneof: "value", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "path", kind: "scalar", oneof: "value", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "call", kind: "message", oneof: "value", T: () => FunctionCall }
        ]);
    }
    create(value?: PartialMessage<DynamicNumber>): DynamicNumber {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.value = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<DynamicNumber>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DynamicNumber): DynamicNumber {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double literal */ 1:
                    message.value = {
                        oneofKind: "literal",
                        literal: reader.double()
                    };
                    break;
                case /* string path */ 2:
                    message.value = {
                        oneofKind: "path",
                        path: reader.string()
                    };
                    break;
                case /* c1.api.a2ui.v1.FunctionCall call */ 3:
                    message.value = {
                        oneofKind: "call",
                        call: FunctionCall.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).call)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DynamicNumber, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* double literal = 1; */
        if (message.value.oneofKind === "literal")
            writer.tag(1, WireType.Bit64).double(message.value.literal);
        /* string path = 2; */
        if (message.value.oneofKind === "path")
            writer.tag(2, WireType.LengthDelimited).string(message.value.path);
        /* c1.api.a2ui.v1.FunctionCall call = 3; */
        if (message.value.oneofKind === "call")
            FunctionCall.internalBinaryWrite(message.value.call, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.DynamicNumber
 */
export const DynamicNumber = new DynamicNumber$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FunctionCall$Type extends MessageType<FunctionCall> {
    constructor() {
        super("c1.api.a2ui.v1.FunctionCall", [
            { no: 1, name: "call", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "args", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 3, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FunctionCall>): FunctionCall {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.call = "";
        message.args = {};
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<FunctionCall>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FunctionCall): FunctionCall {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string call */ 1:
                    message.call = reader.string();
                    break;
                case /* map<string, string> args */ 2:
                    this.binaryReadMap2(message.args, reader, options);
                    break;
                case /* string message */ 3:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: FunctionCall["args"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof FunctionCall["args"] | undefined, val: FunctionCall["args"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.a2ui.v1.FunctionCall.args");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: FunctionCall, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string call = 1; */
        if (message.call !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.call);
        /* map<string, string> args = 2; */
        for (let k of globalThis.Object.keys(message.args))
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.args[k]).join();
        /* string message = 3; */
        if (message.message !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.FunctionCall
 */
export const FunctionCall = new FunctionCall$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ValidationCheck$Type extends MessageType<ValidationCheck> {
    constructor() {
        super("c1.api.a2ui.v1.ValidationCheck", [
            { no: 1, name: "call", kind: "message", oneof: "check", T: () => FunctionCall },
            { no: 2, name: "and", kind: "message", oneof: "check", T: () => AndCheck },
            { no: 3, name: "or", kind: "message", oneof: "check", T: () => OrCheck }
        ]);
    }
    create(value?: PartialMessage<ValidationCheck>): ValidationCheck {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.check = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<ValidationCheck>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ValidationCheck): ValidationCheck {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.a2ui.v1.FunctionCall call */ 1:
                    message.check = {
                        oneofKind: "call",
                        call: FunctionCall.internalBinaryRead(reader, reader.uint32(), options, (message.check as any).call)
                    };
                    break;
                case /* c1.api.a2ui.v1.AndCheck and */ 2:
                    message.check = {
                        oneofKind: "and",
                        and: AndCheck.internalBinaryRead(reader, reader.uint32(), options, (message.check as any).and)
                    };
                    break;
                case /* c1.api.a2ui.v1.OrCheck or */ 3:
                    message.check = {
                        oneofKind: "or",
                        or: OrCheck.internalBinaryRead(reader, reader.uint32(), options, (message.check as any).or)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ValidationCheck, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.a2ui.v1.FunctionCall call = 1; */
        if (message.check.oneofKind === "call")
            FunctionCall.internalBinaryWrite(message.check.call, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.AndCheck and = 2; */
        if (message.check.oneofKind === "and")
            AndCheck.internalBinaryWrite(message.check.and, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.OrCheck or = 3; */
        if (message.check.oneofKind === "or")
            OrCheck.internalBinaryWrite(message.check.or, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.ValidationCheck
 */
export const ValidationCheck = new ValidationCheck$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AndCheck$Type extends MessageType<AndCheck> {
    constructor() {
        super("c1.api.a2ui.v1.AndCheck", [
            { no: 1, name: "checks", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ValidationCheck }
        ]);
    }
    create(value?: PartialMessage<AndCheck>): AndCheck {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.checks = [];
        if (value !== undefined)
            reflectionMergePartial<AndCheck>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AndCheck): AndCheck {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.a2ui.v1.ValidationCheck checks */ 1:
                    message.checks.push(ValidationCheck.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AndCheck, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.a2ui.v1.ValidationCheck checks = 1; */
        for (let i = 0; i < message.checks.length; i++)
            ValidationCheck.internalBinaryWrite(message.checks[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.AndCheck
 */
export const AndCheck = new AndCheck$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrCheck$Type extends MessageType<OrCheck> {
    constructor() {
        super("c1.api.a2ui.v1.OrCheck", [
            { no: 1, name: "checks", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ValidationCheck }
        ]);
    }
    create(value?: PartialMessage<OrCheck>): OrCheck {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.checks = [];
        if (value !== undefined)
            reflectionMergePartial<OrCheck>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrCheck): OrCheck {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.a2ui.v1.ValidationCheck checks */ 1:
                    message.checks.push(ValidationCheck.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrCheck, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.a2ui.v1.ValidationCheck checks = 1; */
        for (let i = 0; i < message.checks.length; i++)
            ValidationCheck.internalBinaryWrite(message.checks[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.OrCheck
 */
export const OrCheck = new OrCheck$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Action$Type extends MessageType<Action> {
    constructor() {
        super("c1.api.a2ui.v1.Action", [
            { no: 1, name: "event", kind: "message", oneof: "actionType", T: () => ServerEvent },
            { no: 2, name: "function_call", kind: "message", oneof: "actionType", T: () => FunctionCall }
        ]);
    }
    create(value?: PartialMessage<Action>): Action {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.actionType = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<Action>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Action): Action {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.a2ui.v1.ServerEvent event */ 1:
                    message.actionType = {
                        oneofKind: "event",
                        event: ServerEvent.internalBinaryRead(reader, reader.uint32(), options, (message.actionType as any).event)
                    };
                    break;
                case /* c1.api.a2ui.v1.FunctionCall function_call */ 2:
                    message.actionType = {
                        oneofKind: "functionCall",
                        functionCall: FunctionCall.internalBinaryRead(reader, reader.uint32(), options, (message.actionType as any).functionCall)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Action, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.a2ui.v1.ServerEvent event = 1; */
        if (message.actionType.oneofKind === "event")
            ServerEvent.internalBinaryWrite(message.actionType.event, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.FunctionCall function_call = 2; */
        if (message.actionType.oneofKind === "functionCall")
            FunctionCall.internalBinaryWrite(message.actionType.functionCall, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.Action
 */
export const Action = new Action$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServerEvent$Type extends MessageType<ServerEvent> {
    constructor() {
        super("c1.api.a2ui.v1.ServerEvent", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "context", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } }
        ]);
    }
    create(value?: PartialMessage<ServerEvent>): ServerEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.context = {};
        if (value !== undefined)
            reflectionMergePartial<ServerEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ServerEvent): ServerEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* map<string, string> context */ 2:
                    this.binaryReadMap2(message.context, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: ServerEvent["context"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ServerEvent["context"] | undefined, val: ServerEvent["context"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.a2ui.v1.ServerEvent.context");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: ServerEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* map<string, string> context = 2; */
        for (let k of globalThis.Object.keys(message.context))
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.context[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.ServerEvent
 */
export const ServerEvent = new ServerEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChildList$Type extends MessageType<ChildList> {
    constructor() {
        super("c1.api.a2ui.v1.ChildList", [
            { no: 1, name: "ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ChildList>): ChildList {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.ids = [];
        if (value !== undefined)
            reflectionMergePartial<ChildList>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ChildList): ChildList {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string ids */ 1:
                    message.ids.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ChildList, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string ids = 1; */
        for (let i = 0; i < message.ids.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.ids[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.ChildList
 */
export const ChildList = new ChildList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Choice$Type extends MessageType<Choice> {
    constructor() {
        super("c1.api.a2ui.v1.Choice", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "label", kind: "message", T: () => DynamicString },
            { no: 3, name: "description", kind: "message", T: () => DynamicString }
        ]);
    }
    create(value?: PartialMessage<Choice>): Choice {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<Choice>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Choice): Choice {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* c1.api.a2ui.v1.DynamicString label */ 2:
                    message.label = DynamicString.internalBinaryRead(reader, reader.uint32(), options, message.label);
                    break;
                case /* c1.api.a2ui.v1.DynamicString description */ 3:
                    message.description = DynamicString.internalBinaryRead(reader, reader.uint32(), options, message.description);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Choice, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* c1.api.a2ui.v1.DynamicString label = 2; */
        if (message.label)
            DynamicString.internalBinaryWrite(message.label, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.DynamicString description = 3; */
        if (message.description)
            DynamicString.internalBinaryWrite(message.description, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.Choice
 */
export const Choice = new Choice$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TextComponent$Type extends MessageType<TextComponent> {
    constructor() {
        super("c1.api.a2ui.v1.TextComponent", [
            { no: 1, name: "text", kind: "message", T: () => DynamicString },
            { no: 2, name: "markdown", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<TextComponent>): TextComponent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.markdown = false;
        if (value !== undefined)
            reflectionMergePartial<TextComponent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TextComponent): TextComponent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.a2ui.v1.DynamicString text */ 1:
                    message.text = DynamicString.internalBinaryRead(reader, reader.uint32(), options, message.text);
                    break;
                case /* bool markdown */ 2:
                    message.markdown = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TextComponent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.a2ui.v1.DynamicString text = 1; */
        if (message.text)
            DynamicString.internalBinaryWrite(message.text, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool markdown = 2; */
        if (message.markdown !== false)
            writer.tag(2, WireType.Varint).bool(message.markdown);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.TextComponent
 */
export const TextComponent = new TextComponent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TextFieldComponent$Type extends MessageType<TextFieldComponent> {
    constructor() {
        super("c1.api.a2ui.v1.TextFieldComponent", [
            { no: 1, name: "label", kind: "message", T: () => DynamicString },
            { no: 2, name: "placeholder", kind: "message", T: () => DynamicString },
            { no: 3, name: "value", kind: "message", T: () => DynamicString },
            { no: 4, name: "multiline", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "checks", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FunctionCall }
        ]);
    }
    create(value?: PartialMessage<TextFieldComponent>): TextFieldComponent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.multiline = false;
        message.checks = [];
        if (value !== undefined)
            reflectionMergePartial<TextFieldComponent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TextFieldComponent): TextFieldComponent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.a2ui.v1.DynamicString label */ 1:
                    message.label = DynamicString.internalBinaryRead(reader, reader.uint32(), options, message.label);
                    break;
                case /* c1.api.a2ui.v1.DynamicString placeholder */ 2:
                    message.placeholder = DynamicString.internalBinaryRead(reader, reader.uint32(), options, message.placeholder);
                    break;
                case /* c1.api.a2ui.v1.DynamicString value */ 3:
                    message.value = DynamicString.internalBinaryRead(reader, reader.uint32(), options, message.value);
                    break;
                case /* bool multiline */ 4:
                    message.multiline = reader.bool();
                    break;
                case /* repeated c1.api.a2ui.v1.FunctionCall checks */ 5:
                    message.checks.push(FunctionCall.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TextFieldComponent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.a2ui.v1.DynamicString label = 1; */
        if (message.label)
            DynamicString.internalBinaryWrite(message.label, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.DynamicString placeholder = 2; */
        if (message.placeholder)
            DynamicString.internalBinaryWrite(message.placeholder, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.DynamicString value = 3; */
        if (message.value)
            DynamicString.internalBinaryWrite(message.value, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* bool multiline = 4; */
        if (message.multiline !== false)
            writer.tag(4, WireType.Varint).bool(message.multiline);
        /* repeated c1.api.a2ui.v1.FunctionCall checks = 5; */
        for (let i = 0; i < message.checks.length; i++)
            FunctionCall.internalBinaryWrite(message.checks[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.TextFieldComponent
 */
export const TextFieldComponent = new TextFieldComponent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckBoxComponent$Type extends MessageType<CheckBoxComponent> {
    constructor() {
        super("c1.api.a2ui.v1.CheckBoxComponent", [
            { no: 1, name: "label", kind: "message", T: () => DynamicString },
            { no: 2, name: "value", kind: "message", T: () => DynamicBool }
        ]);
    }
    create(value?: PartialMessage<CheckBoxComponent>): CheckBoxComponent {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CheckBoxComponent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CheckBoxComponent): CheckBoxComponent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.a2ui.v1.DynamicString label */ 1:
                    message.label = DynamicString.internalBinaryRead(reader, reader.uint32(), options, message.label);
                    break;
                case /* c1.api.a2ui.v1.DynamicBool value */ 2:
                    message.value = DynamicBool.internalBinaryRead(reader, reader.uint32(), options, message.value);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CheckBoxComponent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.a2ui.v1.DynamicString label = 1; */
        if (message.label)
            DynamicString.internalBinaryWrite(message.label, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.DynamicBool value = 2; */
        if (message.value)
            DynamicBool.internalBinaryWrite(message.value, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.CheckBoxComponent
 */
export const CheckBoxComponent = new CheckBoxComponent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChoicePickerComponent$Type extends MessageType<ChoicePickerComponent> {
    constructor() {
        super("c1.api.a2ui.v1.ChoicePickerComponent", [
            { no: 1, name: "label", kind: "message", T: () => DynamicString },
            { no: 2, name: "choices", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Choice },
            { no: 3, name: "value", kind: "message", T: () => DynamicString },
            { no: 4, name: "multi_select", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ChoicePickerComponent>): ChoicePickerComponent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.choices = [];
        message.multiSelect = false;
        if (value !== undefined)
            reflectionMergePartial<ChoicePickerComponent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ChoicePickerComponent): ChoicePickerComponent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.a2ui.v1.DynamicString label */ 1:
                    message.label = DynamicString.internalBinaryRead(reader, reader.uint32(), options, message.label);
                    break;
                case /* repeated c1.api.a2ui.v1.Choice choices */ 2:
                    message.choices.push(Choice.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* c1.api.a2ui.v1.DynamicString value */ 3:
                    message.value = DynamicString.internalBinaryRead(reader, reader.uint32(), options, message.value);
                    break;
                case /* bool multi_select */ 4:
                    message.multiSelect = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ChoicePickerComponent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.a2ui.v1.DynamicString label = 1; */
        if (message.label)
            DynamicString.internalBinaryWrite(message.label, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.a2ui.v1.Choice choices = 2; */
        for (let i = 0; i < message.choices.length; i++)
            Choice.internalBinaryWrite(message.choices[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.DynamicString value = 3; */
        if (message.value)
            DynamicString.internalBinaryWrite(message.value, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* bool multi_select = 4; */
        if (message.multiSelect !== false)
            writer.tag(4, WireType.Varint).bool(message.multiSelect);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.ChoicePickerComponent
 */
export const ChoicePickerComponent = new ChoicePickerComponent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DateTimeInputComponent$Type extends MessageType<DateTimeInputComponent> {
    constructor() {
        super("c1.api.a2ui.v1.DateTimeInputComponent", [
            { no: 1, name: "label", kind: "message", T: () => DynamicString },
            { no: 2, name: "value", kind: "message", T: () => DynamicString },
            { no: 3, name: "input_type", kind: "enum", T: () => ["c1.api.a2ui.v1.DateTimeInputType", DateTimeInputType, "DATE_TIME_INPUT_TYPE_"] },
            { no: 4, name: "min", kind: "message", T: () => DynamicString },
            { no: 5, name: "max", kind: "message", T: () => DynamicString }
        ]);
    }
    create(value?: PartialMessage<DateTimeInputComponent>): DateTimeInputComponent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.inputType = 0;
        if (value !== undefined)
            reflectionMergePartial<DateTimeInputComponent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DateTimeInputComponent): DateTimeInputComponent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.a2ui.v1.DynamicString label */ 1:
                    message.label = DynamicString.internalBinaryRead(reader, reader.uint32(), options, message.label);
                    break;
                case /* c1.api.a2ui.v1.DynamicString value */ 2:
                    message.value = DynamicString.internalBinaryRead(reader, reader.uint32(), options, message.value);
                    break;
                case /* c1.api.a2ui.v1.DateTimeInputType input_type */ 3:
                    message.inputType = reader.int32();
                    break;
                case /* c1.api.a2ui.v1.DynamicString min */ 4:
                    message.min = DynamicString.internalBinaryRead(reader, reader.uint32(), options, message.min);
                    break;
                case /* c1.api.a2ui.v1.DynamicString max */ 5:
                    message.max = DynamicString.internalBinaryRead(reader, reader.uint32(), options, message.max);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DateTimeInputComponent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.a2ui.v1.DynamicString label = 1; */
        if (message.label)
            DynamicString.internalBinaryWrite(message.label, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.DynamicString value = 2; */
        if (message.value)
            DynamicString.internalBinaryWrite(message.value, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.DateTimeInputType input_type = 3; */
        if (message.inputType !== 0)
            writer.tag(3, WireType.Varint).int32(message.inputType);
        /* c1.api.a2ui.v1.DynamicString min = 4; */
        if (message.min)
            DynamicString.internalBinaryWrite(message.min, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.DynamicString max = 5; */
        if (message.max)
            DynamicString.internalBinaryWrite(message.max, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.DateTimeInputComponent
 */
export const DateTimeInputComponent = new DateTimeInputComponent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SliderComponent$Type extends MessageType<SliderComponent> {
    constructor() {
        super("c1.api.a2ui.v1.SliderComponent", [
            { no: 1, name: "label", kind: "message", T: () => DynamicString },
            { no: 2, name: "value", kind: "message", T: () => DynamicNumber },
            { no: 3, name: "min", kind: "message", T: () => DynamicNumber },
            { no: 4, name: "max", kind: "message", T: () => DynamicNumber },
            { no: 5, name: "step", kind: "message", T: () => DynamicNumber }
        ]);
    }
    create(value?: PartialMessage<SliderComponent>): SliderComponent {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SliderComponent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SliderComponent): SliderComponent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.a2ui.v1.DynamicString label */ 1:
                    message.label = DynamicString.internalBinaryRead(reader, reader.uint32(), options, message.label);
                    break;
                case /* c1.api.a2ui.v1.DynamicNumber value */ 2:
                    message.value = DynamicNumber.internalBinaryRead(reader, reader.uint32(), options, message.value);
                    break;
                case /* c1.api.a2ui.v1.DynamicNumber min */ 3:
                    message.min = DynamicNumber.internalBinaryRead(reader, reader.uint32(), options, message.min);
                    break;
                case /* c1.api.a2ui.v1.DynamicNumber max */ 4:
                    message.max = DynamicNumber.internalBinaryRead(reader, reader.uint32(), options, message.max);
                    break;
                case /* c1.api.a2ui.v1.DynamicNumber step */ 5:
                    message.step = DynamicNumber.internalBinaryRead(reader, reader.uint32(), options, message.step);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SliderComponent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.a2ui.v1.DynamicString label = 1; */
        if (message.label)
            DynamicString.internalBinaryWrite(message.label, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.DynamicNumber value = 2; */
        if (message.value)
            DynamicNumber.internalBinaryWrite(message.value, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.DynamicNumber min = 3; */
        if (message.min)
            DynamicNumber.internalBinaryWrite(message.min, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.DynamicNumber max = 4; */
        if (message.max)
            DynamicNumber.internalBinaryWrite(message.max, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.DynamicNumber step = 5; */
        if (message.step)
            DynamicNumber.internalBinaryWrite(message.step, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.SliderComponent
 */
export const SliderComponent = new SliderComponent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ButtonComponent$Type extends MessageType<ButtonComponent> {
    constructor() {
        super("c1.api.a2ui.v1.ButtonComponent", [
            { no: 1, name: "label", kind: "message", T: () => DynamicString },
            { no: 2, name: "action", kind: "message", T: () => Action },
            { no: 3, name: "disabled", kind: "message", T: () => DynamicBool },
            { no: 4, name: "variant", kind: "enum", T: () => ["c1.api.a2ui.v1.ButtonComponent.ButtonVariant", ButtonComponent_ButtonVariant, "BUTTON_VARIANT_"] },
            { no: 5, name: "checks", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ValidationCheck }
        ]);
    }
    create(value?: PartialMessage<ButtonComponent>): ButtonComponent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.variant = 0;
        message.checks = [];
        if (value !== undefined)
            reflectionMergePartial<ButtonComponent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ButtonComponent): ButtonComponent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.a2ui.v1.DynamicString label */ 1:
                    message.label = DynamicString.internalBinaryRead(reader, reader.uint32(), options, message.label);
                    break;
                case /* c1.api.a2ui.v1.Action action */ 2:
                    message.action = Action.internalBinaryRead(reader, reader.uint32(), options, message.action);
                    break;
                case /* c1.api.a2ui.v1.DynamicBool disabled */ 3:
                    message.disabled = DynamicBool.internalBinaryRead(reader, reader.uint32(), options, message.disabled);
                    break;
                case /* c1.api.a2ui.v1.ButtonComponent.ButtonVariant variant */ 4:
                    message.variant = reader.int32();
                    break;
                case /* repeated c1.api.a2ui.v1.ValidationCheck checks */ 5:
                    message.checks.push(ValidationCheck.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ButtonComponent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.a2ui.v1.DynamicString label = 1; */
        if (message.label)
            DynamicString.internalBinaryWrite(message.label, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.Action action = 2; */
        if (message.action)
            Action.internalBinaryWrite(message.action, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.DynamicBool disabled = 3; */
        if (message.disabled)
            DynamicBool.internalBinaryWrite(message.disabled, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.ButtonComponent.ButtonVariant variant = 4; */
        if (message.variant !== 0)
            writer.tag(4, WireType.Varint).int32(message.variant);
        /* repeated c1.api.a2ui.v1.ValidationCheck checks = 5; */
        for (let i = 0; i < message.checks.length; i++)
            ValidationCheck.internalBinaryWrite(message.checks[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.ButtonComponent
 */
export const ButtonComponent = new ButtonComponent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RowComponent$Type extends MessageType<RowComponent> {
    constructor() {
        super("c1.api.a2ui.v1.RowComponent", [
            { no: 1, name: "children", kind: "message", T: () => ChildList },
            { no: 2, name: "distribution", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "alignment", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "gap", kind: "message", T: () => DynamicNumber }
        ]);
    }
    create(value?: PartialMessage<RowComponent>): RowComponent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.distribution = "";
        message.alignment = "";
        if (value !== undefined)
            reflectionMergePartial<RowComponent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RowComponent): RowComponent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.a2ui.v1.ChildList children */ 1:
                    message.children = ChildList.internalBinaryRead(reader, reader.uint32(), options, message.children);
                    break;
                case /* string distribution */ 2:
                    message.distribution = reader.string();
                    break;
                case /* string alignment */ 3:
                    message.alignment = reader.string();
                    break;
                case /* c1.api.a2ui.v1.DynamicNumber gap */ 4:
                    message.gap = DynamicNumber.internalBinaryRead(reader, reader.uint32(), options, message.gap);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RowComponent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.a2ui.v1.ChildList children = 1; */
        if (message.children)
            ChildList.internalBinaryWrite(message.children, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string distribution = 2; */
        if (message.distribution !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.distribution);
        /* string alignment = 3; */
        if (message.alignment !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.alignment);
        /* c1.api.a2ui.v1.DynamicNumber gap = 4; */
        if (message.gap)
            DynamicNumber.internalBinaryWrite(message.gap, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.RowComponent
 */
export const RowComponent = new RowComponent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ColumnComponent$Type extends MessageType<ColumnComponent> {
    constructor() {
        super("c1.api.a2ui.v1.ColumnComponent", [
            { no: 1, name: "children", kind: "message", T: () => ChildList },
            { no: 2, name: "distribution", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "alignment", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "gap", kind: "message", T: () => DynamicNumber }
        ]);
    }
    create(value?: PartialMessage<ColumnComponent>): ColumnComponent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.distribution = "";
        message.alignment = "";
        if (value !== undefined)
            reflectionMergePartial<ColumnComponent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ColumnComponent): ColumnComponent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.a2ui.v1.ChildList children */ 1:
                    message.children = ChildList.internalBinaryRead(reader, reader.uint32(), options, message.children);
                    break;
                case /* string distribution */ 2:
                    message.distribution = reader.string();
                    break;
                case /* string alignment */ 3:
                    message.alignment = reader.string();
                    break;
                case /* c1.api.a2ui.v1.DynamicNumber gap */ 4:
                    message.gap = DynamicNumber.internalBinaryRead(reader, reader.uint32(), options, message.gap);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ColumnComponent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.a2ui.v1.ChildList children = 1; */
        if (message.children)
            ChildList.internalBinaryWrite(message.children, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string distribution = 2; */
        if (message.distribution !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.distribution);
        /* string alignment = 3; */
        if (message.alignment !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.alignment);
        /* c1.api.a2ui.v1.DynamicNumber gap = 4; */
        if (message.gap)
            DynamicNumber.internalBinaryWrite(message.gap, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.ColumnComponent
 */
export const ColumnComponent = new ColumnComponent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CardComponent$Type extends MessageType<CardComponent> {
    constructor() {
        super("c1.api.a2ui.v1.CardComponent", [
            { no: 1, name: "children", kind: "message", T: () => ChildList }
        ]);
    }
    create(value?: PartialMessage<CardComponent>): CardComponent {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CardComponent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CardComponent): CardComponent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.a2ui.v1.ChildList children */ 1:
                    message.children = ChildList.internalBinaryRead(reader, reader.uint32(), options, message.children);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CardComponent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.a2ui.v1.ChildList children = 1; */
        if (message.children)
            ChildList.internalBinaryWrite(message.children, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.CardComponent
 */
export const CardComponent = new CardComponent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DividerComponent$Type extends MessageType<DividerComponent> {
    constructor() {
        super("c1.api.a2ui.v1.DividerComponent", [
            { no: 1, name: "orientation", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DividerComponent>): DividerComponent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.orientation = "";
        if (value !== undefined)
            reflectionMergePartial<DividerComponent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DividerComponent): DividerComponent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string orientation */ 1:
                    message.orientation = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DividerComponent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string orientation = 1; */
        if (message.orientation !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.orientation);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.DividerComponent
 */
export const DividerComponent = new DividerComponent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class C1StatusIndicatorComponent$Type extends MessageType<C1StatusIndicatorComponent> {
    constructor() {
        super("c1.api.a2ui.v1.C1StatusIndicatorComponent", [
            { no: 1, name: "status", kind: "message", T: () => DynamicString },
            { no: 2, name: "message", kind: "message", T: () => DynamicString },
            { no: 3, name: "tool_name", kind: "message", T: () => DynamicString },
            { no: 4, name: "show_spinner", kind: "message", T: () => DynamicBool }
        ]);
    }
    create(value?: PartialMessage<C1StatusIndicatorComponent>): C1StatusIndicatorComponent {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<C1StatusIndicatorComponent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: C1StatusIndicatorComponent): C1StatusIndicatorComponent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.a2ui.v1.DynamicString status */ 1:
                    message.status = DynamicString.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* c1.api.a2ui.v1.DynamicString message */ 2:
                    message.message = DynamicString.internalBinaryRead(reader, reader.uint32(), options, message.message);
                    break;
                case /* c1.api.a2ui.v1.DynamicString tool_name */ 3:
                    message.toolName = DynamicString.internalBinaryRead(reader, reader.uint32(), options, message.toolName);
                    break;
                case /* c1.api.a2ui.v1.DynamicBool show_spinner */ 4:
                    message.showSpinner = DynamicBool.internalBinaryRead(reader, reader.uint32(), options, message.showSpinner);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: C1StatusIndicatorComponent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.a2ui.v1.DynamicString status = 1; */
        if (message.status)
            DynamicString.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.DynamicString message = 2; */
        if (message.message)
            DynamicString.internalBinaryWrite(message.message, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.DynamicString tool_name = 3; */
        if (message.toolName)
            DynamicString.internalBinaryWrite(message.toolName, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.DynamicBool show_spinner = 4; */
        if (message.showSpinner)
            DynamicBool.internalBinaryWrite(message.showSpinner, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.C1StatusIndicatorComponent
 */
export const C1StatusIndicatorComponent = new C1StatusIndicatorComponent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class C1CodeBlockComponent$Type extends MessageType<C1CodeBlockComponent> {
    constructor() {
        super("c1.api.a2ui.v1.C1CodeBlockComponent", [
            { no: 1, name: "code", kind: "message", T: () => DynamicString },
            { no: 2, name: "language", kind: "message", T: () => DynamicString },
            { no: 3, name: "title", kind: "message", T: () => DynamicString },
            { no: 4, name: "copyable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<C1CodeBlockComponent>): C1CodeBlockComponent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.copyable = false;
        if (value !== undefined)
            reflectionMergePartial<C1CodeBlockComponent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: C1CodeBlockComponent): C1CodeBlockComponent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.a2ui.v1.DynamicString code */ 1:
                    message.code = DynamicString.internalBinaryRead(reader, reader.uint32(), options, message.code);
                    break;
                case /* c1.api.a2ui.v1.DynamicString language */ 2:
                    message.language = DynamicString.internalBinaryRead(reader, reader.uint32(), options, message.language);
                    break;
                case /* c1.api.a2ui.v1.DynamicString title */ 3:
                    message.title = DynamicString.internalBinaryRead(reader, reader.uint32(), options, message.title);
                    break;
                case /* bool copyable */ 4:
                    message.copyable = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: C1CodeBlockComponent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.a2ui.v1.DynamicString code = 1; */
        if (message.code)
            DynamicString.internalBinaryWrite(message.code, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.DynamicString language = 2; */
        if (message.language)
            DynamicString.internalBinaryWrite(message.language, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.DynamicString title = 3; */
        if (message.title)
            DynamicString.internalBinaryWrite(message.title, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* bool copyable = 4; */
        if (message.copyable !== false)
            writer.tag(4, WireType.Varint).bool(message.copyable);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.C1CodeBlockComponent
 */
export const C1CodeBlockComponent = new C1CodeBlockComponent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class C1ResourcePickerComponent$Type extends MessageType<C1ResourcePickerComponent> {
    constructor() {
        super("c1.api.a2ui.v1.C1ResourcePickerComponent", [
            { no: 1, name: "label", kind: "message", T: () => DynamicString },
            { no: 2, name: "value", kind: "message", T: () => DynamicString },
            { no: 3, name: "resource_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "multi_select", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<C1ResourcePickerComponent>): C1ResourcePickerComponent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.resourceType = "";
        message.multiSelect = false;
        if (value !== undefined)
            reflectionMergePartial<C1ResourcePickerComponent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: C1ResourcePickerComponent): C1ResourcePickerComponent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.a2ui.v1.DynamicString label */ 1:
                    message.label = DynamicString.internalBinaryRead(reader, reader.uint32(), options, message.label);
                    break;
                case /* c1.api.a2ui.v1.DynamicString value */ 2:
                    message.value = DynamicString.internalBinaryRead(reader, reader.uint32(), options, message.value);
                    break;
                case /* string resource_type */ 3:
                    message.resourceType = reader.string();
                    break;
                case /* bool multi_select */ 4:
                    message.multiSelect = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: C1ResourcePickerComponent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.a2ui.v1.DynamicString label = 1; */
        if (message.label)
            DynamicString.internalBinaryWrite(message.label, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.DynamicString value = 2; */
        if (message.value)
            DynamicString.internalBinaryWrite(message.value, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string resource_type = 3; */
        if (message.resourceType !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.resourceType);
        /* bool multi_select = 4; */
        if (message.multiSelect !== false)
            writer.tag(4, WireType.Varint).bool(message.multiSelect);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.C1ResourcePickerComponent
 */
export const C1ResourcePickerComponent = new C1ResourcePickerComponent$Type();
